<template>
  <!-- Main container for the page -->
  <div class="min-h-screen font-sans bg-brand-bg text-brand-dark">
    <Header class="bg-gray-100" />
    <div
      class="flex flex-col items-center px-4 py-8 font-sans text-gray-800 bg-white"
    >
      <!-- Main content area for the FAQs -->
      <main class="flex-1 w-full max-w-3xl">
        <h1
          class="mb-8 text-2xl font-semibold text-center text-black sm:text-3xl"
        >
          Pre-sales Questions
        </h1>

        <!-- Product Toggles / Switching Buttons -->
        <div class="flex justify-center mb-10 space-x-4">
          <button
            v-for="(product, key) in allFaqs"
            :key="key"
            @click="activeProduct = key"
            :class="[
              'px-6 py-2 font-semibold rounded-full focus:outline-none transition-colors duration-300',
              activeProduct === key
                ? 'bg-brand-red text-white shadow'
                : 'bg-gray-200 text-gray-700 hover:bg-red-300',
            ]"
          >
            {{ product.name }}
          </button>
        </div>

        <!-- FAQ items are generated by looping through the data of the active product -->
        <!-- Each FAQ item is now a self-contained block with spacing -->
        <div v-for="(faq, index) in currentFaqs" :key="index" class="mb-10">
          <!-- Question Section -->
          <div class="flex gap-4 items-start">
            <!-- "Q" Avatar Icon -->
            <div
              class="flex flex-shrink-0 justify-center items-center w-10 h-10 font-bold text-gray-600 bg-gray-100 rounded-full"
            >
              Q
            </div>
            <!-- Question Text -->
            <h2 class="flex-1 mt-1.5 text-lg font-semibold text-gray-900">
              {{ faq.question }}
            </h2>
          </div>

          <!-- Answer Section -->
          <div class="flex gap-4 items-start mt-4">
            <!-- "A" Avatar Icon -->
            <div
              class="flex flex-shrink-0 justify-center items-center w-10 h-10 font-bold text-white bg-rose-500 rounded-full"
            >
              A
            </div>
            <!-- Answer Text, using v-html to render formatted lists -->
            <p
              class="flex-1 mt-1.5 leading-relaxed text-gray-600"
              v-html="faq.answer"
            ></p>
          </div>
        </div>

        <!-- Final contact information section -->
        <div
          class="pt-6 mt-8 leading-relaxed text-left text-gray-600 border-t border-gray-200"
        >
          <p>
            If there are have any other questions, please don’t hesitate to
            contact our support team at
            <a
              href="mailto:after-service@elephas.com.hk"
              class="font-medium text-rose-500 hover:underline"
              >after-service@elephas.com.hk</a
            >.
          </p>
          <p class="mt-2">
            We’re always here to help and ensure you have the best experience.
          </p>
        </div>
      </main>

      <!-- <Footer /> -->
    </div>
  </div>
</template>

<script>
// import Footer from '@/components/footer.vue'
import Header from "@/components/header";
import allFaqs from "@/views/FAQ_data.js";
export default {
  name: "PreSalesQuestions",
  components: {
    Header,
  },
  data() {
    return {
      // 1. Add state to track the currently active product
      activeProduct: "googleTV", // Default product to show

      // 2. Restructure FAQs into an object, where each key is a product
      allFaqs,
    };
  },
  computed: {
    // 3. Create a computed property to get the FAQs for the currently active product
    currentFaqs() {
      // It will automatically update when `activeProduct` changes
      return this.allFaqs[this.activeProduct]?.faqs || [];
    },
  },
};
</script>
